import React from 'react';
import  './ProjectCard.css';

export default function ProjectCard({ project, onShareClick }) {
    return (
        <div className = "card-container">
            <div className='card-inner'>
                <div className='card-front'>
                    <h3 className = "project-address">{project.address}</h3>
                </div>

                <div className='card-back'>
                    <h4> Quick Info</h4>
                    <p> Status: {project.status}</p>
                    <div className="card-back-actions">
                        <button>View Photos</button>
                        <button
                            className="card-share-btn"
                            onClick={(e) => {
                                e.stopPropagation();
                                onShareClick && onShareClick(project.id, project.name || project.address);
                            }}
                        >
                            Share
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}